import Vue from 'vue'

export const CognitoEventBus = new Vue()
